export default function COperators() {
  return <h2>C Operators</h2>;
}
